import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import FAQSection from '../components/FAQSection';
import { bonuses, faqs } from '../mockData';
import { Gift, Clock, CheckCircle, AlertCircle, TrendingUp, ChevronDown, ChevronUp } from 'lucide-react';

const Aktionen = () => {
  const [isContentExpanded, setIsContentExpanded] = useState(false);

  useEffect(() => {
    document.title = 'Robocat Casino Aktionen & Bonus Angebote 2025 | Deutschland';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Aktuelle Robocat Casino Bonusangebote ⚡ Willkommensbonus 500€ + 200 FS ✓ Bonus Code ✓ Promo Code ✓ Regelmäßige Aktionen & Turniere');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 to-slate-900">
      {/* Header with Banner */}
      <section className="relative py-20 md:py-32 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_futuristic-casino-1/artifacts/aigi8kvv_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.14.06.png" 
            alt="Robocat Casino Aktionen Banner" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-slate-950/95 via-slate-900/90 to-blue-950/95"></div>
        </div>
        
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-600 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <Gift className="w-16 h-16 text-cyan-400 mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Robocat Casino <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">Aktionen</span> & Bonusangebote
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed mb-8">
              Entdecken Sie die großzügigsten Bonusangebote und Aktionen bei Robocat Casino. Von Willkommensboni bis hin zu exklusiven Turnieren - hier finden Sie alle aktuellen Promotions für deutsche Spieler.
            </p>
            <Button 
              size="lg" 
              className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold px-8 py-6 text-lg shadow-2xl shadow-cyan-500/50 hover:shadow-cyan-500/70 transition-all duration-300"
              onClick={() => alert('Demo: Bonus aktivieren')}
            >
              <Gift className="mr-2 w-5 h-5" />
              Jetzt Bonus sichern
            </Button>
          </div>
        </div>
      </section>

      {/* All Bonuses */}
      <section className="py-16 bg-slate-950">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">Alle verfügbaren Bonusangebote</h2>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {bonuses.map((bonus, index) => {
                const bonusImages = [
                  "https://customer-assets.emergentagent.com/job_futuristic-casino-1/artifacts/86n5ynh1_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.14.00.png",
                  "https://customer-assets.emergentagent.com/job_futuristic-casino-1/artifacts/3royeyz9_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.13.47.png",
                  "https://customer-assets.emergentagent.com/job_futuristic-casino-1/artifacts/rdpp1v0r_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2008.20.10.png",
                  "https://customer-assets.emergentagent.com/job_futuristic-casino-1/artifacts/abge20ij_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2006.09.25.png"
                ];
                
                return (
                  <Card key={bonus.id} className={`bg-slate-800/50 border-cyan-500/20 p-8 hover:shadow-xl hover:shadow-cyan-500/20 transition-all duration-300 relative overflow-hidden flex flex-col ${
                    bonus.featured ? 'border-2 border-cyan-500/50' : ''
                  }`}>
                    <div className="absolute inset-0 opacity-15">
                      <img 
                        src={bonusImages[index % bonusImages.length]} 
                        alt={`${bonus.title} Hintergrund`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    
                    {bonus.featured && (
                      <div className="absolute top-4 right-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-4 py-1 rounded-full text-sm font-bold z-20">
                        Empfohlen
                      </div>
                    )}
                    
                    <div className="relative z-10 flex flex-col flex-grow">
                      <div className="mb-6">
                        <h3 className="text-2xl font-bold text-white mb-3">{bonus.title}</h3>
                        <div className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent mb-2">
                          {bonus.amount}
                        </div>
                        {bonus.extras && (
                          <div className="text-lg text-cyan-400 font-semibold">{bonus.extras}</div>
                        )}
                      </div>
                      
                      <p className="text-gray-300 leading-relaxed mb-6">{bonus.description}</p>
                      
                      <div className="space-y-3 mb-6 flex-grow">
                        <div className="flex items-start space-x-2">
                          <CheckCircle className="w-5 h-5 text-green-400 mt-0.5 flex-shrink-0" />
                          <div>
                            <div className="text-sm font-semibold text-white">Bedingungen</div>
                            <div className="text-sm text-gray-400">{bonus.requirements}</div>
                          </div>
                        </div>
                        <div className="flex items-start space-x-2">
                          <Clock className="w-5 h-5 text-cyan-400 mt-0.5 flex-shrink-0" />
                          <div>
                            <div className="text-sm font-semibold text-white">Gültigkeit</div>
                            <div className="text-sm text-gray-400">{bonus.validUntil}</div>
                          </div>
                        </div>
                      </div>
                      
                      <Button 
                        className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold shadow-lg mt-auto"
                        onClick={() => alert('Demo: Bonus aktivieren')}
                      >
                        Bonus aktivieren
                      </Button>
                    </div>
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Bonus Tips */}
      <section className="py-16 bg-slate-900">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">Tipps zur Bonusnutzung</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Card className="bg-slate-800/50 border-cyan-500/20 p-6">
                <CheckCircle className="w-8 h-8 text-green-400 mb-4" />
                <h3 className="text-xl font-bold text-white mb-3">AGB sorgfältig lesen</h3>
                <p className="text-gray-300 leading-relaxed">
                  Lesen Sie immer die vollständigen Bonusbedingungen, bevor Sie einen Bonus aktivieren. Achten Sie besonders auf Umsatzanforderungen, zeitliche Begrenzungen und ausgeschlossene Spiele.
                </p>
              </Card>
              
              <Card className="bg-slate-800/50 border-cyan-500/20 p-6">
                <TrendingUp className="w-8 h-8 text-cyan-400 mb-4" />
                <h3 className="text-xl font-bold text-white mb-3">Spiele mit hohem RTP wählen</h3>
                <p className="text-gray-300 leading-relaxed">
                  Wählen Sie Spiele mit hoher Rückzahlungsquote (RTP), um Ihre Chancen auf die Erfüllung der Umsatzanforderungen zu maximieren. Slots mit 96%+ RTP sind ideal.
                </p>
              </Card>
              
              <Card className="bg-slate-800/50 border-cyan-500/20 p-6">
                <Clock className="w-8 h-8 text-blue-400 mb-4" />
                <h3 className="text-xl font-bold text-white mb-3">Zeitlimits beachten</h3>
                <p className="text-gray-300 leading-relaxed">
                  Boni haben oft zeitliche Begrenzungen. Planen Sie genügend Zeit ein, um die Umsatzbedingungen innerhalb der vorgegebenen Frist zu erfüllen.
                </p>
              </Card>
              
              <Card className="bg-slate-800/50 border-cyan-500/20 p-6">
                <AlertCircle className="w-8 h-8 text-yellow-400 mb-4" />
                <h3 className="text-xl font-bold text-white mb-3">Nur ein Bonus gleichzeitig</h3>
                <p className="text-gray-300 leading-relaxed">
                  Bei Robocat Casino kann immer nur ein Bonus aktiv sein. Stellen Sie sicher, dass Sie Ihren aktuellen Bonus abgeschlossen haben, bevor Sie einen neuen aktivieren.
                </p>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Content with Dropdown - Before FAQs */}
      <section className="py-16 bg-slate-950">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-slate-800/50 border border-cyan-500/20 rounded-2xl overflow-hidden">
              <button
                onClick={() => setIsContentExpanded(!isContentExpanded)}
                className="w-full px-8 py-6 flex items-center justify-between hover:bg-slate-800/70 transition-colors"
              >
                <h2 className="text-2xl md:text-3xl font-bold text-white text-left">
                  Robocat Casino Bonus: Umfassender Leitfaden für 2025
                </h2>
                {isContentExpanded ? (
                  <ChevronUp className="w-6 h-6 text-cyan-400 flex-shrink-0 ml-4" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-cyan-400 flex-shrink-0 ml-4" />
                )}
              </button>
              
              <div className="px-8 pb-8 space-y-6">
                <p className="text-gray-300 leading-relaxed">
                  Robocat Casino bietet eines der großzügigsten Bonusprogramme in der deutschen Online-Casino-Landschaft. Mit einem Willkommensbonus von bis zu 500 € plus 200 Freispielen...
                </p>
                
                {isContentExpanded && (
                  <div className="space-y-6 animate-in slide-in-from-top duration-300">
                    <p className="text-gray-300 leading-relaxed">
                      Robocat Casino bietet eines der großzügigsten Bonusprogramme in der deutschen Online-Casino-Landschaft. Mit einem Willkommensbonus von bis zu 500 € plus 200 Freispielen und einem Bonus Crab starten neue Spieler mit einem erheblichen Vorteil. Doch das ist erst der Anfang - Robocat Casino belohnt seine treuen Spieler mit regelmäßigen Aktionen, Turnieren und exklusiven VIP-Angeboten.
                    </p>
                    
                    <img 
                      src="https://customer-assets.emergentagent.com/job_futuristic-casino-1/artifacts/8bc1fg4f_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2004.50.31.png" 
                      alt="Robocat Casino Bonusangebote" 
                      className="w-full rounded-lg border border-cyan-500/20 shadow-xl"
                    />
                    
                    <p className="text-gray-300 leading-relaxed">
                      Der Robocat Bonus Code ist nicht erforderlich, da die meisten Boni automatisch bei der Registrierung oder Einzahlung aktiviert werden. Dies vereinfacht den Prozess erheblich und stellt sicher, dass Sie keine Angebote verpassen. Sollten jedoch spezielle Promo Codes für zeitlich begrenzte Aktionen verfügbar sein, werden diese auf der Aktionsseite oder per E-Mail kommuniziert. Achten Sie auf Begriffe wie "robocat promo code", "robocat aktionscode" oder "robocat casino bonus ohne einzahlung" für besondere Angebote.
                    </p>
                    
                    <p className="text-gray-300 leading-relaxed">
                      Die Umsatzbedingungen bei Robocat Casino sind fair und transparent gestaltet. Der Willkommensbonus muss 35-mal umgesetzt werden, bevor eine Auszahlung möglich ist, während der Ersteinzahlungsbonus eine 30-fache Umsatzanforderung hat. Im Vergleich zu vielen anderen Online-Casinos, die oft 40-fache oder sogar 50-fache Umsatzanforderungen haben, sind die Bedingungen bei Robocat sehr spielerfreundlich. Freispielgewinne unterliegen einer 40-fachen Umsatzanforderung, was dem Branchenstandard entspricht.
                    </p>
                    
                    <p className="text-gray-300 leading-relaxed">
                      Neben den Willkommensboni bietet Robocat Casino auch regelmäßige Reload-Boni, Cashback-Angebote und spezielle Turniere mit hohen Preispools. Das Roulette Rennen mit einem Preispool von 8.000 € und das Mega Roulette 3000 mit unglaublichen 250.000 € Gewinnpotenzial sind nur einige der aufregenden Aktionen, die regelmäßig stattfinden. VIP-Spieler profitieren von zusätzlichen Vorteilen wie höheren Einzahlungslimits, schnelleren Auszahlungen und einem persönlichen Account Manager.
                    </p>
                  </div>
                )}
                
                <button
                  onClick={() => setIsContentExpanded(!isContentExpanded)}
                  className="text-cyan-400 hover:text-cyan-300 font-semibold transition-colors flex items-center space-x-2"
                >
                  <span>{isContentExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen'}</span>
                  {isContentExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQSection faqs={faqs.aktionen} title="Häufige Fragen zu Robocat Casino Boni" />
    </div>
  );
};

export default Aktionen;
